import React, { useEffect, useState } from "react";

function Notfound() {
  return (
    <div>
      <div
        className="page-content-wrapper minheight"
        style={{ background: "#ffeed7" }}
      >
        <div className="notfound">Page Not Found</div>
      </div>
      {/* <!-- Footer Nav--> */}
    </div>
  );
}

export default Notfound;
